import moment from 'moment';
import fields from "./fields.utils.js";


const schema_home = {
    ...fields.notes,
    "best_price": {
        label: 'Best Price',
        type: 'number',
        value: 0,
        required: true,

        placeholder: 'Best Price'
    },
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "occupation_x_type": {
        value: '',
        type: 'auto-suggest',
        required: true,
        options: [],
    },
    "claim_x_type": {
        label: "Type",
        type: 'select',
        value: '',
        options: [],
        orderOptions: false,
        placeholder: 'Claim Type'
    },
    "claim_x_date": {
        label: "Date",
        type: 'date-mask',
        value: moment().format("DD/MM/YYYY"),
        placeholder: 'Claim Date'
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,
        placeholder: 'Cover Date'
    },
    "cover_duration": {
        label: 'Cover Duration',
        type: 'select',
        value: '',
        options: [],
        required: true,

    },
    "cover_level": {
        label: 'Cover Level',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    "standard_construction": {
        label: "standard construction",
        value: true,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "history_subsidence": {
        label: "history of subsidence",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "history_flooding": {
        label: "history of flooding",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    "history_thatched_roof": {
        label: "history of thatched roof",
        value: false,
        type: 'bool',
        required: true,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_home;
